import { createCmsProviderAdapter } from '@eneco/cms-sanity';
import { createSitecoreAdapter } from '@eneco/cms-sitecore';
import env from '@eneco/common/env';
// Deep import, NOT the `@eneco/next/server` barrel, which drags server-only modules into the
// browser bundle (see `containers/nl/eneco/mkb/cms-config.ts`).
import { getContainerBasePath } from '@eneco/next/server/utils/getContainerBasePath';

import { sanityPrefixedSites, sanitySite } from './config';

let instance: ReturnType<typeof createSitecoreAdapter> | undefined;

export const getCmsAdapter = () => {
  if (!instance) {
    const layoutServiceUrl = `${env('SITECORE_API_HOST')}${env('SITECORE_LAYOUT_SERVICE_ROUTE')}`;
    const apiKey = env('SITECORE_API_KEY');
    const site = env('SITECORE_API_SITE');
    instance = createSitecoreAdapter({ layoutServiceUrl, apiKey, site });
  }
  return instance;
};

// Serves the `?_cms=` override and Sanity draft mode on acceptance/production too, not just
// development/local (see `allowSharedEnvironment` in `is-sanity-enabled.ts`), the same as
// `containers/nl/eneco/mkb`. Sitecore still serves every unforced request — this only widens
// where the override works. Whether Sanity resolves at all still needs `SANITY_PROJECT_ID` and
// `SANITY_DATASET`; without them the adapter lookup returns nothing and the page renders from Sitecore.
export const { getSanityAdapter, selectCmsAdapter } = createCmsProviderAdapter(getCmsAdapter, {
  site: sanitySite,
  prefixedSites: sanityPrefixedSites,
  allowSharedEnvironment: true,
  basePath: getContainerBasePath(),
});
